import { render, staticRenderFns } from "./PageNumberRange.vue?vue&type=template&id=5d936a28&scoped=true"
import script from "./PageNumberRange.vue?vue&type=script&lang=js"
export * from "./PageNumberRange.vue?vue&type=script&lang=js"
import style0 from "./PageNumberRange.vue?vue&type=style&index=0&id=5d936a28&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d936a28",
  null
  
)

export default component.exports